import gql from 'graphql-tag'

export const fetchPlaceOrderMutation = gql`
mutation ($cart_id: String!, $custom_email: String, $deliveryaftersixpm: String, 
$deliveryonpallet: String, $notefordriver: String,
 $sappaymentmethod: String, $payment_id : String , $payment_method: String , 
 $customerordernumber: String, $delivery_hour_from: String, $delivery_hour_to: String, $sap_surname: String, $sap_name: String, $role: String ) {
  placeOrder(
    input: {
        cart_id: $cart_id
        custom_email: $custom_email
        deliveryaftersixpm: $deliveryaftersixpm
        deliveryonpallet: $deliveryonpallet
        notefordriver: $notefordriver
        sappaymentmethod: $sappaymentmethod
        payment_id: $payment_id
        payment_method: $payment_method,
        customerordernumber: $customerordernumber, 
        delivery_hour_from: $delivery_hour_from ,          
        delivery_hour_to: $delivery_hour_to,
        sap_name: $sap_name,
        sap_surname: $sap_surname,
        role: $role
        }
    )
    {
        order {
            order_number
             customer_order_number
             note_for_driver
             sap_id
        }
    }
}

`
